import { Heading } from 'components/shared/Heading';
import { Layout } from 'components/shared/Layout';
import { Texts } from 'components/shared/Texts';
import React, { FC } from 'react';
import styles from './Error.module.scss';
import { ApiErrorTypes, ApiErrors } from 'utils/strings';

interface ErrorPageViewProps {
  errorCode: ApiErrorTypes;
}

export const ErrorPageView: FC<ErrorPageViewProps> = ({ errorCode }) => {
  return (
    <Layout>
      <section
        className={styles.loading}
        role="alert"
        key={`error_page_view_key`}
      >
        <div className={styles.img_wrapper}>
          <img src="/motylek.png" alt="" />
        </div>
        <Heading type="h1" className={styles.header}>
          {ApiErrors[errorCode].header}
        </Heading>
        {ApiErrors[errorCode].desc && (
          <Texts className={styles.desc}>{ApiErrors[errorCode].desc}</Texts>
        )}
      </section>
    </Layout>
  );
};
